import { ReactNode } from "react";

import { FormEngineViews } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { DefaultWidgetMap, WidgetMap } from "@com.mgmtp.a12.formengine/formengine-core/lib/view";

import { ActivityIdContext } from "../../../component/ActivityContext";
import { CustomActionContentbox } from "../../../component/CustomActionContentbox";

export function TextbausteineFormEngine(props: FormEngineViews.FormEngineProps): ReactNode {
	return (
		<ActivityIdContext.Provider value={props.activityId}>
			<FormEngineViews.FormEngine {...props} widgetMap={widgetMap} />
		</ActivityIdContext.Provider>
	);
}

const widgetMap: WidgetMap = {
	...DefaultWidgetMap,
	ActionContentbox: CustomActionContentbox
};
